import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Heading,
    ModalDialog,
} from '@zillow/constellation';

import ClaimListingCard from 'app/shared/components/ClaimListingCard';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';
import ModalFooter from 'app/shared/components/Modal/ModalFooter';

import ClaimActions from 'app/shared/actions/ClaimActions';
import ListingClaimUtils from 'app/shared/utils/listingClaimUtils';

const { isEmailInContactMethods, isPhoneInContactMethods } = ListingClaimUtils;

const propTypes = {
    isOpen: PropTypes.bool,
    includeUnverified: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
};

const defaultProps = {
    isOpen: true,
    includeUnverified: true,
};

const ViewClaimListingsModal = ({
    isOpen,
    onClose,
    includeUnverified,
}) => {
    const dispatch = useDispatch();
    const [hasError, setHasError] = React.useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [listings, setListings] = useState([]);
    const [contactMethods, setContactMethods] = useState();

    React.useEffect(() => {
        dispatch(ClaimActions.propertyLookupAll({ includeUnverified }))
            .then((response) => {
                setContactMethods(response.contactMethods);
                setListings(response.listings);
            }).catch(() => setHasError(true))
            .finally(() => setIsLoading(false));
    }, []);

    const renderContent = () => {
        if (isLoading) {
            return <SpinnerContainer />;
        }
        return (
            <div>
                {listings.map((listing, i) => (
                    <ClaimListingCard
                        key={`listing-card-${i}`}
                        listingData={listing}
                        highlightPhone={isPhoneInContactMethods(contactMethods, listing.contactPhone)}
                        highlightEmail={isEmailInContactMethods(contactMethods, listing.contactEmail)}
                    />
                ))}
            </div>
        );
    };

    const renderFooter = () => (
        <ModalFooter
            hasError={hasError}
            onSubmit={onClose}
            submitText="Done"
        />
    );

    return (
        <ModalDialog
            isOpen={isOpen}
            onClose={onClose}
            mediaQuery={{ xs: { fullScreen: true }, md: { fullScreen: false } }}
            wide={true}
            header={<Heading level={6}><b>View Listings</b></Heading>}
            body={renderContent()}
            footer={renderFooter()}
        />
    );
};

ViewClaimListingsModal.propTypes = propTypes;
ViewClaimListingsModal.defaultProps = defaultProps;

export default ViewClaimListingsModal;
